module.exports = __webpack_public_path__ + "static/media/show_first_transaction.45b86b9a.svg";